export enum UpsertActionType {
  UPDATE = 'UPDATE',
  SAVE = 'SAVE'
}

export type CategoryNamesPerCombination = {
  combinationId: string,
  categoryNames: string[]
}